import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Helper } from 'src/app/shared/utils/helper';
import { Observable } from 'rxjs';
import { SelectList } from 'src/app/shared/models/select-list';

@Injectable({
  providedIn: 'root'
})
export class ManifestService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getManifestList(filter) {
    const { Page, Query, dateRange ,Sort ,SortDirection, BusinessId } = filter;
    let prm: HttpParams = new HttpParams()
      .set('Page', Page)
      .set('Query', Query)
      .set('BusinessId', BusinessId)
      .set('onlyOwn', "true")
      .set('ManifestType', "Pickup");
      if (dateRange!=null) {
        const fd = Helper.getDateStr(dateRange[0]);
        const td = Helper.getDateStr(dateRange[1]);
        prm = prm.set("DateFrom", fd).set("DateTo", td);
      }
      if (Sort!=null&&SortDirection!=null) {
        prm = prm.set("Sort", Sort).set("SortDirection", SortDirection);
      }
    return this.http.get(`${this.baseUrl}/manifest/cit/list`, { params: prm });
  }

  getManifestInfo(manifestId:string):Observable<any>{
    return this.http.get(`${this.baseUrl}/manifest/consignment/list/cit/${manifestId}`);
  }
  getManifestDetails(manifestId:string):Observable<any>{
    return this.http.get(`${this.baseUrl}/manifest/view/${manifestId}`);
  }

  confirmManifest(manifestId:string, pickupContactId:string):Observable<any>{
    const data = {id:manifestId, pickupContactId}
    return this.http.post(`${this.baseUrl}/manifest/confirm`, data);
  }
  closeManifest(manifestId:string):Observable<any>{
    const data = {id:manifestId}
    return this.http.post(`${this.baseUrl}/manifest/close`, data);
  }

  put_mainfest(data){
    return this.http.put(`${this.baseUrl}/manifest/edit`,data)
  }

  get_businessPickLocationSelectList(params:HttpParams):Observable<Array<SelectList>>{
    params = params.set("businessId",Helper.getUserObject('businessId'));
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/business/contact/selectlist`, {params})
    .pipe(
      map((r)=>r.result)
    )
  }

  get_area(pickupLocationPostcode:Required<string>, consignmentIds:Required<Array<string>>){
    const payload = {OriginPostcode: pickupLocationPostcode, ConsignmentIds:consignmentIds};
    return this.http.post(`${this.baseUrl}/billingzone/postcode/area`, payload);
  }


  cancel_Booking(data){
    return this.http.post(`${this.baseUrl}/job/cancelbooking`,data);
  }
  nextDay_Booking(data){
    return this.http.post(`${this.baseUrl}/job/nextdaybooking`,data);
  }
  delete_Booking(data){
    return this.http.post(`${this.baseUrl}/job/deletebooking`,data);
  }

  delete_Manifest(id:string){
    return this.http.delete(`${this.baseUrl}/manifest/delete/${id}`);
  }

  get_manifestReport(id){
    let params = new HttpParams().set("ManifestNo",id);
    return this.http.get(`${this.baseUrl}/report/manifestdetail`, {params:params, responseType: 'blob'});
  }

  get_mainfestItem(id){
    return this.http.get(`${this.baseUrl}/manifest/item/view/ems/${id}`);
  }

  delete_deleteConsignmentfromManifest(id:string){
    return this.http.delete(`${this.baseUrl}/manifest/delete/itemjob/${id}`);
  }

  get_stationByBusinessId(businessId){
    const params = new HttpParams().set("onlyOwn", "true")
    return this.http.get(`${this.baseUrl}/station/selectlist/bybusiness/${businessId}`,{params:params});
  }


  get_status(){
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/manifest/selectlist/statuses`)
  }

  get_types(){
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/manifest/selectlist/types`)
  }

  post_manifest(data){
    return this.http.post(`${this.baseUrl}/manifest/create/ems`, data);
  }

  put_manifest(data){
    return this.http.put(`${this.baseUrl}/manifest/edit`, data);
  }

}
